import bildA from '@/assets/img/bild-a.png'
import bildB from '@/assets/img/bild-b.png'
import bildC from '@/assets/img/bild-c.png'
import bildE from '@/assets/img/bild-e.png'
import bildG from '@/assets/img/bild-g.png'
import bildH from '@/assets/img/bild-h.png'
import bildM from '@/assets/img/bild-m.png'
import bildNext from '@/assets/img/nextTerm.png'



export const IMAGE_TYPES = Object.freeze({
  UNDEFINED_IMAGE: 'undefined',
  QUESTIONAIRE_IMAGE: 'questionaire',
  INTERVIEW_IMAGE: 'interview',
  POST_IMAGE: 'post',
  WRITE_TASK_IMAGE: 'write',
  TERM_SELECT_IMAGE: 'term',
  WAIT_IMAGE: 'wait',
  THANK_YOU_IMAGE: 'thanks',
})

const FALLBACK_IMAGE = bildA

const IMAGE_MAP = {
  [IMAGE_TYPES.UNDEFINED_IMAGE]: bildA,
  [IMAGE_TYPES.QUESTIONAIRE_IMAGE]: bildB,
  [IMAGE_TYPES.INTERVIEW_IMAGE]: bildC,
  [IMAGE_TYPES.POST_IMAGE]: bildE,
  [IMAGE_TYPES.WRITE_TASK_IMAGE]: bildG,
  [IMAGE_TYPES.TERM_SELECT_IMAGE]: bildH,
  [IMAGE_TYPES.WAIT_IMAGE]: bildM,
  [IMAGE_TYPES.THANK_YOU_IMAGE]: bildNext,
}

export function getImageUrl(type) {
  return IMAGE_MAP[type] || FALLBACK_IMAGE
}
